export class GetTableDataQualitySettingsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "settings",
            "baseName": "settings",
            "type": "TableDataQualitySettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualitySettingsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
